<!-- 分页组件 -->
<template>
  <div class="page" onselectstart = "return false" v-if="page.count">
  <template v-if="page.total>1">
    <button type="button" class="paging" @click="gotoPage(-1)" :disabled="page.current==1">{{$t('components.vpage.previous_page')}}</button>
    <button type="button" v-for="(p,index) in pages" :key="index" :disabled="p =='...'"  :class="{'current-page': p ==page.current}" @click="gotoPage(p)">{{p}}</button>
    <button type="button" class="paging" @click="gotoPage(0)" :disabled="page.current ==page.total">{{$t('components.vpage.next_page')}}</button>
    <span>{{$t('components.vpage.the')}} <input type="text" v-model.lazy="current" :style="{width:String(page.total).length+'em'}" style="text-align:center;min-width:2em" /> {{$t('components.vpage.page')}}</span>
  </template>
    <span>{{$t('components.vpage.each_page')}} <v-select v-model.lazy="page.sel" :placeholder="String(page.limit)" :options="[{name:5,value:5},{name:10,value:10},{name:20,value:20},{name:30,value:30},{name:40,value:40}]" :width="50"></v-select>{{$t('components.common.tiao')}}</span>
  <span>{{$t('components.vpage.total')}}{{page.count}}{{$t('components.common.tiao')}}</span>
  </div>
</template>

<script>
import store from '@/server/store.js'
export default {
  name: "VPage",
  props:{
    page:{
      type:Object,
      default:function () {
        return {
          limit:10,
          count:0,
          current:1,
          total:1
        }
      }
    }
  },
  data() {
    return {
      id:0
    }
  },
  watch:{
    'page.current':function (val) {
      store.save('page'+this.id,val)
    },
    //最后一页仅有一条数据删除后total减一,page.current减一
    'page.total':function (val) {
       if (this.page.current > val) {
        this.gotoPage(val)
       }
    }
  },
  computed:{
    current:{
      get:function () {
        return this.page.current;
      },
      set:function (val) {
        if(+val<1) {
          this.page.current = 1;
        } else if(+val>this.page.total) {
          this.page.current = this.page.total;
        } else if(+val>0){
          this.page.current = +val;
        } else {
          this.page.current = 1;
        }
      }
    },
    pages: function () {
       let c = +this.page.current
       let l = +this.page.total
       let arr = [1,2,3,4,5,'...',l]
       if (l <= 11) {
         return Array.apply(null,{length:l}).map((v,i)=> i + 1)
       }else{
          if (c <= 5) {
            return arr;
          }else{
            if (c + 4 < l) {
              return [1,'...',c-1,c,c+1,'...',l]
            }else{
              return [1,'...',l-4,l-3,l-2,l-1,l]
            }
          }
       }
    }
  },
  methods:{
    gotoPage(page){
      switch (page) {
        case 0:
          this.page.current++
          break;
        case -1:
          this.page.current--
          break;
        default:
          this.page.current = page
          break;
      }
    }
  },
   mounted() {
     this.$route.meta.__mixin_count ++;
     this.id = this.$route.meta.__mixin_count;
     if(this.$route.query.page) {
       var page = +store.fetch('page' + this.id);
       if (page > 0) {
         this.page.current = store.fetch('page' + this.id);
       }
     }
   }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/varible.less';
.page{
  height: 30px;
  line-height: 1.5;
  font-size: 16px;
  color:#8d8d8d;
  button{
    color:@blue;
    display: inline-block;
    min-width: 22px;
    height: 22px;
    line-height: 100%;
    font-size: 85%;
    margin: 0 2px;
    border-radius:2px;
    padding: 0 3px;
  }
  span{
   vertical-align: middle;
  }
  .paging{
    width: 58px;
    height: 28px;
    color:@blue;
    padding: 4px;
    border:1px solid @blue;
    border-radius: 4px;
  }
}
button[disabled]{
  cursor: not-allowed;
}
.page button.current-page{
  background:@blue;
  color:#fff;
}

</style>
